module.exports = __webpack_public_path__ + "img/inner-card.09b46e47.svg";